import type { RegisteredWidget } from 'tio-employee/utils/partner-dashboard/registry';

/**
 * Every partner dashboard widget, in the order it renders within its section.
 * Add a widget here with `defineWidget`; the route loads and the page renders
 * only the ones the viewer's personas drive.
 */
export const PARTNER_DASHBOARD_WIDGETS: readonly RegisteredWidget[] = [];
